module.exports = __webpack_public_path__ + "static/media/brett&jesse.bb72c117.jpeg";